export const getOccupationalGroupNumber = (number) => {
  if (
    !window.SchoolSettings.metafields.first_parent.occupational_group
      .is_letter_for_occupational_group_enabled
  ) {
    return number;
  }
  return {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
    8: "N",
    9: "U",
  }[number];
};

export const getOccupationalGroupOptions = () => [
  {
    value: 1,
    text: `Group ${getOccupationalGroupNumber(
      1,
    )} – Senior management in large business organisation, government administration and defence, and qualified professionals`,
  },
  {
    value: 2,
    text: `Group ${getOccupationalGroupNumber(
      2,
    )} – Other business managers, arts/media/sportspersons and associate professionals`,
  },
  {
    value: 3,
    text: `Group ${getOccupationalGroupNumber(
      3,
    )} – Tradesmen/women, clerks and skilled office, sales and service staff`,
  },
  {
    value: 4,
    text: `Group ${getOccupationalGroupNumber(
      4,
    )} – Machine operators, hospitality staff, assistants, labourers and related workers`,
  },
  {
    value: 8,
    text: `Group ${getOccupationalGroupNumber(
      8,
    )} – Have not been in paid work in the last 12 months`,
  },
  {
    value: 9,
    text: `Group ${getOccupationalGroupNumber(9)} – Not stated or unknown`,
  },
];
